import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {path: '/totalMap', component: () => import('@/views/totalMap'), hidden: true},
  {path: '/MonitorList', component: () => import('@/views/MonitorList'), hidden: true},
  {path: '/visitListMap',component: () => import('@/views/TbVisit/visitListMap'),hidden:true},
  // {path: 'vifivList',name: 'vifivList',component: () => import('@/views/vifivList'),hidden:true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/userWx',
    component: Layout,
    redirect: '/userWx/userWx',
    name: 'userWx',
    meta: {title: '微信用户'},
    children: [
      {
        path: 'wxuser',
        name: 'wxuser',
        component: () => import('@/views/UserWx/index'),
        meta: {title: '用户列表'}
      },
      {
        path: 'wxuserInfo',
        name: 'wxuserInfo',
        component: () => import('@/views/UserWx/addupdate'),
        meta: {title: '微信用户详情'},
        hidden: true
      }
    ]
  },
  {
    path: '/statistical',
    component: Layout,
    redirect: '/statistical/export',
    name: 'statistical',
    meta: {title: '报表管理'},
    children: [
      {
        path: 'infoDataExport',
        name: 'infoDataExport',
        component: () => import('@/views/export/infoDataExport'),
        meta: {title: '详情数据'}
      },
      {
        path: 'pooledAnalyseExport',
        name: 'pooledAnalyseExport',
        component: () => import('@/views/export/pooledAnalyseExport'),
        meta: {title: '汇总分析'}
      },{
        path: 'thatPersonDataExport',
        name: 'thatPersonDataExport',
        component: () => import('@/views/export/thatPersonDataExport'),
        meta: {title: '人员详情数据'}
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/sms',
    name: 'sms',
    meta: {title: '运营中心'},
    children: [
      {
        path: 'searchInfo',
        name: 'searchInfo',
        component: () => import('@/views/SearchInfo/index'),
        meta: {title: '搜索信息'}
      },
      {
        path: 'userOrder',
        name: 'userOrder',
        component: () => import('@/views/UserOrder/index'),
        meta: {title: '订单管理'}
      },
      {
        path: 'addupdateUserOrder',
        name: 'addupdateUserOrder',
        component: () => import('@/views/UserOrder/addupdate'),
        meta: {title: '订单详情'},
        hidden:true
      }
    ]
  },
  {
    path:'/businessManagement',
    component: Layout,
    redirect: '/TbCompany/index',
    name: 'businessManagement',
    meta: {title: '业务管理'},
    children: [
      {
        path: 'TbMember',
        name: 'TbMember',
        component: () => import('@/views/TbMember/index'),
        meta: {title: '老人管理'}
      },
      {
        path: 'addupdateTbMember',
        name: 'addupdateTbMember',
        component: () => import('@/views/TbMember/addupdateTbMember'),
        meta: {title: '老人详情'},
        hidden:true
      },
      {
        path: 'TbWorker',
        name: 'TbWorker',
        component: () => import('@/views/TbWorker/index'),
        meta: {title: '护工管理'}
      },
      {
        path: 'addupdateTbWorker',
        name: 'addupdateTbWorker',
        component: () => import('@/views/TbWorker/addupdateTbWorker'),
        meta: {title: '护工详情'},
        hidden:true
      },
      {
        path: 'TbVisit',
        name: 'TbVisit',
        component: () => import('@/views/TbVisit/index'),
        meta: {title: '服务记录'}
      },
      {
        path: 'addupdateTbVisit',
        name: 'addupdateTbVisit',
        component: () => import('@/views/TbVisit/addupdateTbVisit'),
        meta: {title: '考勤详情'},
        hidden:true
      },
      {
        path: 'TbNews',
        name: 'TbNews',
        component: () => import('@/views/TbNews/index'),
        meta: {title: '通知管理'}
      },
      {
        path: 'addupdateTbNews',
        name: 'addupdateTbNews',
        component: () => import('@/views/TbNews/addupdateTbNews'),
        meta: {title: '通知详情'},
        hidden:true
      },
      {
        path: 'publishTbNews',
        name: 'publishTbNews',
        component: () => import('@/views/TbNews/publishTbNews'),
        meta: {title: '发布通知'},
        hidden:true
      },
      {
        path: 'TbFirstLoc',
        name: 'TbFirstLoc',
        component: () => import('@/views/TbFirstLoc/index'),
        meta: {title: '首次定位照'}
      },

      {
        path: 'TbChange',
        name: 'TbChange',
        component: () => import('@/views/TbChange/index'),
        meta: {title: '提前换人'}
      },
      {
        path: 'addupdateTbChange',
        name: 'addupdateTbChange',
        component: () => import('@/views/TbChange/addupdateTbChange'),
        meta: {title: '提前换人详情'}
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限管理'},
    children: [
      {
        path: 'addupdateTbType',
        name: 'addupdateTbType',
        component: () => import('@/views/TbType/addupdateTbType'),
        meta: {title: '分区详情'},
        hidden: true
      },
      {
        path: 'TbType',
        name: 'TbType',
        component: () => import('@/views/TbType/index'),
        meta: {title: '分区管理'}
      },
      {
        path: 'addupdateTbTown',
        name: 'addupdateTbTown',
        component: () => import('@/views/TbTown/addupdateTbTown'),
        meta: {title: '乡镇详情'},
        hidden: true
      },
      {
        path: 'TbTown',
        name: 'TbTown',
        component: () => import('@/views/TbTown/index'),
        meta: {title: '乡镇列表'}
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'updatePassword',
        name: 'updatePassword',
        component: () => import('@/views/updatePassword'),
        meta: {title: '修改密码'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  /**去掉url中的#*/
  mode: 'history',
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap.concat(asyncRouterMap)
})




// WEBPACK FOOTER //
// ./src/router/index.js